import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, FormControl, Grid, InputLabel, MenuItem, Select, Switch, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class Subjects extends Component {
  state = {
    allJobs: [],
    togglingArIds: {},
    togglingAgriBoostIds: {},
    message: "",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notification: false,
    noticolor: "success",
    per_page: 20,
    page_no: 1,
    redirect: false,
  };
  componentDidMount() {
    this.getAllSubjects(this.state.page_no, this.state.per_page);
  }

  getAllSubjects = (page, limit) => {
    if (init() === "success") {
      // console.log("called");
      axios
        .get(`${Constants.getUrls.getAllSubjects}?page=${page}&limit=${limit}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              allJobs: resp.data.data.docs,
              pagination: resp.data.data, // whole pagination object from backend
              page_no: resp.data.data.page,
              notification: true,
              noticolor: "success",
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState({ notification: false, message: "" });
            }, 2500);
          } else {
            this.setState({
              notification: true,
              noticolor: "error",
              message: resp.data.message,
            });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.message || "Error fetching questions",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllSubjects(1, newLimit); // reset to first page with new limit
    });
  };

  // ✅ Handle page change (from DataTable)
  handlePageChange = (newPage) => {
    this.getAllSubjects(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteSubject + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState(
                {
                  notification: false,
                  message: "",
                },
                () => {
                  this.getAllSubjects();
                }
              );
            }, 2500);
          }
        })
        .catch((err) => {
          //   console.log(err);
          this.setState({
            notification: true,
            message: err.response?.message,
          });
          setTimeout(() => {
            this.setState(
              {
                notification: false,
                message: "",
              },
              () => {
                this.getAllSubjects();
              }
            );
          }, 2500);
        });
    } else {
      window.location.assign("/");
    }
  };

  handleArToggle = (id) => {
    if (init() === "success") {
      this.setState(
        (prevState) => ({
          togglingArIds: {
            ...prevState.togglingArIds,
            [id]: true,
          },
        }),
        () => {
          axios
            .put(Constants.putUrls.toggleSubjectAr + id)
            .then((resp) => {
              this.setState({
                notification: true,
                noticolor: resp?.data?.status === "success" ? "success" : "error",
                message: resp?.data?.message || "AR status updated.",
              });
              this.getAllSubjects(this.state.page_no, this.state.per_page);
            })
            .catch((err) => {
              this.setState({
                notification: true,
                noticolor: "error",
                message: err?.response?.data?.message || "Unable to update AR status.",
              });
            })
            .finally(() => {
              this.setState((prevState) => ({
                togglingArIds: {
                  ...prevState.togglingArIds,
                  [id]: false,
                },
              }));
              setTimeout(() => {
                this.setState({ notification: false, message: "" });
              }, 2500);
            });
        }
      );
    } else {
      window.location.assign("/");
    }
  };

  handleAgriBoostToggle = (id) => {
    if (init() === "success") {
      this.setState(
        (prevState) => ({
          togglingAgriBoostIds: {
            ...prevState.togglingAgriBoostIds,
            [id]: true,
          },
        }),
        () => {
          axios
            .put(Constants.putUrls.toggleSubjectAgriBoost + id)
            .then((resp) => {
              this.setState({
                notification: true,
                noticolor: resp?.data?.status === "success" ? "success" : "error",
                message: resp?.data?.message || "AgriBoost status updated.",
              });
              this.getAllSubjects(this.state.page_no, this.state.per_page);
            })
            .catch((err) => {
              this.setState({
                notification: true,
                noticolor: "error",
                message: err?.response?.data?.message || "Unable to update AgriBoost status.",
              });
            })
            .finally(() => {
              this.setState((prevState) => ({
                togglingAgriBoostIds: {
                  ...prevState.togglingAgriBoostIds,
                  [id]: false,
                },
              }));
              setTimeout(() => {
                this.setState({ notification: false, message: "" });
              }, 2500);
            });
        }
      );
    } else {
      window.location.assign("/");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    } else {
      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Subject List
                  </MDTypography>
                </MDBox>
                <Grid item sm={4} px={2} align="right">
                  <Link to="/addsubject">
                    <MDButton variant="contained" size="small" color="primary">
                      Create
                    </MDButton>
                  </Link>
                </Grid>
                <MDBox>
                  <DataTable
                    table={{
                      columns: [
                        { Header: "serial", accessor: "serial", width: "6%" },
                        { Header: "Post", accessor: "name" },
                        { Header: "AR", accessor: "ar_enabled" },
                        { Header: "AgriBoost", accessor: "agriboost_enabled" },
                        // { Header: "content", accessor: "content" },
                        { Header: "image", accessor: "image" },
                        { Header: "action", accessor: "action" },
                      ],
                      rows: this.state.allJobs.map((job, index) => ({
                        serial: index + 1,
                        name: job.subject_name,
                        ar_enabled: (
                          <Switch
                            checked={job.ar_enabled !== false}
                            disabled={Boolean(this.state.togglingArIds[job._id])}
                            onChange={() => this.handleArToggle(job._id)}
                            color="success"
                          />
                        ),
                        agriboost_enabled: (
                          <Switch
                            checked={job.agriboost_enabled !== false}
                            disabled={Boolean(this.state.togglingAgriBoostIds[job._id])}
                            onChange={() => this.handleAgriBoostToggle(job._id)}
                            color="success"
                          />
                        ),
                        image: (
                          <>
                            <img src={Constants.imageDomain + job.subject_poster} height="100px" />
                          </>
                        ),
                        // content: job.content,

                        action: (
                          <>
                            <div>
                              <Link
                                to={{
                                  pathname: "/updatesubject/" + job._id,
                                  state: { data: job },
                                }}
                              >
                                <MDButton variant="outlined" size="small" color="success">
                                  Update
                                </MDButton>
                              </Link>
                            </div>
                            <div style={{ marginTop: "1rem" }}>
                              <MDButton
                                variant="outlined"
                                size="small"
                                color="error"
                                onClick={() => this.handleDelete(job._id)}
                              >
                                Delete
                              </MDButton>
                            </div>
                          </>
                        ),
                      })),
                    }}
                    entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                    page_no={this.state.pagination?.page}
                    totalPages={this.state.pagination?.totalPages}
                    hasNextPage={this.state.pagination?.hasNextPage}
                    hasPrevPage={this.state.pagination?.hasPrevPage}
                    isnextPage={this.state.pagination?.nextPage}
                    prevPage={this.state.pagination?.prevPage}
                    totalDocs={this.state.pagination?.totalDocs}
                    onPageChange={this.handlePageChange}
                    onEntriesPerPageChange={this.handleEntriesPerPageChange}
                  />
                </MDBox>
                <>
                  <MDSnackbar
                    color={this.state.noticolor}
                    icon="notifications"
                    title="AgriQuiz "
                    content={this.state.message}
                    dateTime="Just now"
                    open={this.state.notification}
                    //   close={toggleSnackbar}
                  />
                </>
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
